import React, { useState, useEffect } from 'react';
import './Navbar.css'; // We'll keep all styles in this CSS file
import Logo from '../../../Assert/Image/oldlogo.png';
const Navbarpermicesls = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Toggle body scroll when menu opens/closes
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
    // Cleanup
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  // Initialize AOS (simple scroll animations) – include the library via CDN in public/index.html
  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({
        duration: 900,
        once: true,
        offset: 120,
        easing: 'ease-out-quad'
      });
    }
  }, []);

  // Pulse effect interval (optional)
  useEffect(() => {
    const interval = setInterval(() => {
      const badges = document.querySelectorAll('.badge');
      badges.forEach((badge, index) => {
        if (index % 3 === 0) {
          badge.classList.toggle('pulse');
        }
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const toggleMenu = () => setMenuOpen(prev => !prev);

  return (
    <>
      {/* HEADER (identical design) */}
      <header className="header">
        <div className="logo-img">
          <img
            src={Logo}
            alt="Permixcels logo"
            onError={(e) => e.target.src = 'https://via.placeholder.com/150x40/f05423/white?text=Permixcels'}
            style={{ width: '140px' }}
          />
        </div>
        <ul className="nav-links">
          <li><a href="./index.html">Home</a></li>
          <li><a href="./about.html">About Us</a></li>
          <li><a href="./services.html">Services</a></li>
          <li><a href="./careers.html">Careers</a></li>
          <li><a href="./contact.html">Contact</a></li>
        </ul>
        <div
          className={`hamburger ${menuOpen ? 'active' : ''}`}
          id="hamburger"
          onClick={toggleMenu}
        >
          <span></span><span></span><span></span>
        </div>
      </header>

       {/* MEGA MENU (fixed) */}
      <div className={`mega-menu ${menuOpen ? 'open' : ''}`} id="megaMenu">
        <div style={{ marginBottom: '20px' }}>
          <img
            src={Logo}
            alt="Permixcels"
            style={{ width: '140px' }}
            onError={(e) => e.target.src = 'https://via.placeholder.com/140x40/f05423/white?text=Permixcels'}
          />
        </div>
        <div className="close-btn" id="closeBtn" onClick={toggleMenu}>&times;</div>
        <div className="menu-grid">
          <ul className="menu-list">
            <li><a href="./index.html"><i className="fas fa-home"></i> Home</a></li>
            <li><a href="./about.html"><i className="fas fa-users"></i> About</a></li>
            <li><a href="./careers.html"><i className="fas fa-briefcase"></i> Careers</a></li>
            <li><a href="./insights.html"><i className="fas fa-blog"></i> Insights</a></li>
          </ul>
          <ul className="menu-list">
            <li><a href="./web-development.html"><i className="fas fa-code"></i> Web Dev</a></li>
            <li><a href="./mobile-apps.html"><i className="fas fa-mobile-alt"></i> Mobile Apps</a></li>
            <li><a href="./ui-ux.html"><i className="fas fa-pencil-ruler"></i> UI/UX</a></li>
          </ul>
          <ul className="menu-list">
            <li><a href="./digital-marketing.html"><i className="fas fa-chart-line"></i> Digital Marketing</a></li>
            <li><a href="./branding.html"><i className="fas fa-palette"></i> Branding</a></li>
            <li><a href="./photography.html"><i className="fas fa-camera"></i> Photography</a></li>
          </ul>
          <ul className="menu-list">
            <li><a href="#"><i className="fab fa-react"></i> React</a></li>
            <li><a href="#"><i className="fab fa-node-js"></i> Node.js</a></li>
            <li><a href="#"><i className="fab fa-python"></i> Python</a></li>
            <li><a href="#"><i className="fas fa-database"></i> SQL</a></li>
          </ul>
        </div>
        <div className="company-details">
          <div className="company-info">
            <h3>Permixcels Technologies</h3>
            <p>We build scalable digital products combining innovation and creativity.</p>
            <div className="contact-info">
              <p><i className="fas fa-map-marker-alt"></i> Tiruchirappalli, Tamil Nadu</p>
              <p><i className="fas fa-phone"></i> +91 98765 43210</p>
              <p><i className="fas fa-envelope"></i> info@permixcels.com</p>
            </div>
          </div>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-behance"></i></a>
          </div>
        </div>
      </div>

   

 


    </>
  );
};

export default Navbarpermicesls;